// extracted by mini-css-extract-plugin
export default {"st0":"WarningIcon_st0__dFyOZ","st1":"WarningIcon_st1__yPFvA","st2":"WarningIcon_st2__X4+th","st3":"WarningIcon_st3__ezqp+","st4":"WarningIcon_st4__nsaxp"};